export default "__VITE_ASSET__4765f2ce__"